import { useTheme } from '@material-ui/core';
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
} from '@react-google-maps/api';
import { appEnv } from 'app/core/environment';
import styledConsts from 'app/styles/styledConsts';
import React from 'react';
import { GeocodeCoords } from 'react-geocode';

const coloredMarker = (color: string, size = 1): google.maps.Icon => {
  const baseW = 22;
  const baseH = 30;
  const w = baseW * size;
  const h = baseH * size;
  return {
    url: `data:image/svg+xml,${encodeURIComponent(
      [
        `<svg viewBox="0 0 ${baseW} ${baseH}" xmlns="http://www.w3.org/2000/svg">`,
        `<path d="m 12.5,27.5 c -0.5,2.5 -2.5,2.5 -3,0 C 8.5,21.5 1,18 1,11.5 v 0 c 0,-5 4.5,-10 10,-10 5.5,0 10,5 10,10 0,6.5 -7.5,10 -8.5,16 z" fill="${color}" stroke="#ffffff" stroke-width="1"/>`,
        '<circle cx="11" cy="11.5" r="3" fill="#ffffff"/>',
        '</svg>',
      ].join('')
    )}`,
    anchor: new window.google.maps.Point(w / 2, h),
    scaledSize: new window.google.maps.Size(w, h),
  };
};

const adjustCoords = (
  position: GeocodeCoords,
  delta: GeocodeCoords
) => ({
  lat: position.lat + delta.lat,
  lng: position.lng + delta.lng,
});

export type MapProps = {
  currentLocation: GeocodeCoords;
};
function SimpleMapComponent({
  currentLocation,
}: MapProps): JSX.Element {
  const theme = useTheme();
  const defaultMapOptions = {
    fullscreenControl: false,
    zoomControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    zoom: 8,
    options: {
      draggable: false,
    },
  };

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: appEnv.GOOGLE_API_KEY,
  });

  const onLoad = (mapProp: google.maps.Map) => {
    const milesW = 5;
    const coordsW = milesW / 60;
    const bounds = new window.google.maps.LatLngBounds(
      adjustCoords(currentLocation, { lat: -coordsW, lng: -coordsW }),
      adjustCoords(currentLocation, { lat: coordsW, lng: coordsW })
    );
    mapProp.fitBounds(bounds);
  };
  return (
    <>
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={{
            flex: '1 1 auto',
            width: '100%',
            height: '200px',
            borderRadius: '10px',
          }}
          options={defaultMapOptions}
          onLoad={onLoad}
          center={currentLocation}
        >
          <Marker
            position={{
              lat: currentLocation.lat,
              lng: currentLocation.lng,
            }}
            icon={coloredMarker(styledConsts.cError({ theme }), 1.1)}
          />
        </GoogleMap>
      )}
    </>
  );
}

export default SimpleMapComponent;
